import { render, staticRenderFns } from "./trans.vue?vue&type=template&id=9bae4140&scoped=true"
import script from "./trans.vue?vue&type=script&lang=js"
export * from "./trans.vue?vue&type=script&lang=js"
import style0 from "./trans.vue?vue&type=style&index=0&id=9bae4140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bae4140",
  null
  
)

export default component.exports